//import * as common from '@/store/mutation-types';

export const SEARCH_PARAM = 'SEARCH_PARAM';
export const CAR_SALE_LIST = 'CAR_SALE_LIST';
export const PAGING_INFO = 'PAGING_INFO';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const STATE_INIT = 'STATE_INIT';
export default {
	//...common,
	SEARCH_PARAM,
	CAR_SALE_LIST,
	PAGING_INFO,
	DEFAULT_ASSIGN,
	STATE_INIT
};
